import { VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import APCommonDialog from "../../../components/modals/APCommonDialog";
import LevelSelect from "../../../components/LevelSelect";
import APTextarea from "../../../components/APTextarea";
import { TAGS_LIST } from "../../../constants/Scenario";
import { useVocabIntl } from "../../../hooks/useVocabTranslation";

interface ScenarioAddModalProps {
  onCreate: (name: string, levels: string[]) => void;
  open: boolean;
  onClose: () => void;
  scenarioName: string;
  tags: string[];
  editMode?: boolean;
}

interface LevelOption {
  value: string;
  label: string;
}

export default function ScenarioAddModal(props: ScenarioAddModalProps) {
  const { onCreate, open, onClose, scenarioName, tags, editMode } = props;

  const { getFormattedString } = useVocabIntl()

  const [name, setName] = useState("");
  const nameCharsLimit = 100;
  const [selectedLevels, setSelectedLevels] = useState<LevelOption[]>(
    []
  );

  useEffect(() => {
    setName(scenarioName);
  }, [scenarioName]);

  useEffect(() => {
    setSelectedLevels(
      TAGS_LIST.filter((tagOption) => tags.includes(tagOption.value)).map(
        (tag) => ({
          value: tag.value,
          label: tag.label,
        })
      )
    );
  }, [tags]);

  const handleCreate = () => {
    onCreate(
      name,
      selectedLevels.map((level) => level.value)
    );
  };

  return (
    <APCommonDialog
      open={open}
      title={getFormattedString(editMode ? "settings" : "create-list-heading")}
      onNext={handleCreate}
      onClose={onClose}
      error={false}
      btnTitle={getFormattedString(editMode ? "save-button" : "start-button")}
      btnTabIndex={3}
    >
      <VStack marginY={2} alignItems={"stretch"} width={"90%"}>
        <APTextarea key={"ScenarioName"} colorScheme={"tertiary"} variant={"outline"} maxLength={nameCharsLimit}
                    value={name}
                    placeholder="Nom de la liste"
                    tabIndex={1}
                    aria-label={getFormattedString('aria-label-list-name-input')}
                    onChange={(e) => setName(e.target.value)} resize={"none"} />
        <LevelSelect
          label="select"
          options={TAGS_LIST.map((tag) => ({
            value: tag.value,
            label: tag.label,
          }))}
          buttonProps={{ sx: { background: "#ebebeb", borderRadius: "8px" } }}
          onChange={(options: LevelOption[]) => setSelectedLevels(options)}
          placeholder={getFormattedString('choose-level')}
          value={selectedLevels}
          tabIndex={2}
        />
      </VStack>
    </APCommonDialog>
  );
}
